module.exports = __webpack_public_path__ + "img/avatar6.ab4ae77c.png";